import React from 'react';

import styles from './activityFeedPageStyles';
// Some stuff for the site header/footer
import 'assets/stylesheets/core/_base';
import 'assets/stylesheets/modules/_icons';
import 'assets/stylesheets/modules/_bio';

import ActivityFeedArea from 'buyside/components/presentation/ActivityFeedArea/activityFeedArea';
import LeftSidebar from 'buyside/components/presentation/LeftSidebar/leftSidebar';
import RightSidebar from 'buyside/components/presentation/RightSidebar/rightSidebar';

const ActivityFeedPage = ({ currentUser }) => {
  const { canViewUserDetails, canWriteIdeas, canWriteWhitePapers } = currentUser;

  return (
    <div className={styles.pageLayout}>
      <div className={styles.leftSideColumn}>
        <LeftSidebar />
      </div>
      <div className={styles.middleColumn}>
        <ActivityFeedArea
          currentUser={currentUser}
          showPostSubmission
          showUpdateSubscriptionsFeedItem
        />
      </div>
      <div className={styles.rightSideColumn}>
        <RightSidebar
          canViewUserDetails={canViewUserDetails}
          canWriteIdeas={canWriteIdeas}
          canWriteWhitePapers={canWriteWhitePapers}
        />
      </div>
    </div>
  );
};

export default ActivityFeedPage;
